export const capitalizeFirstLetter = (input) => input.charAt(0).toUpperCase() + input.slice(1);
